import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postCreateTournament = (params) => {
    return axios.post(`${backendHost}/api/admin/tournament/create`, params);
};

export {
    postCreateTournament
}